<template>
    <div class="animated userDutyPage fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 clientStaffTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="fm_officers"
                        arrows >
                    <template slot="gofixTab:fm_officers">
                        <gofix-split>
                            <template slot="gofixSplit:left">
                                <gofix-card fullContent class="allUser" classHeader="m-0" classContent="m-0">
                                    <h3 class="allUserItem" v-bind:class="{active : !userGroups.active}" @click="changeGroupID(null)">ALL Users</h3>
                                </gofix-card>
                                <gofix-card fullContent title="FM Team" classHeader="pl-20" class="groupUser">
                                    <template slot="gofixCard:right_header">
                                        <div class="d-flex justify-content-end align-items-center">
                                            <span @click="openGroupModal(1)" class="mr-2 cursor-pointer" title="Create FM team" v-b-tooltip.hover>
                                                <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.526 4.91855L10.1127 0.505273C9.98965 0.382227 9.82353 0.3125 9.64922 0.3125H0.9375C0.574512 0.3125 0.28125 0.605762 0.28125 0.96875V18.0312C0.28125 18.3942 0.574512 18.6875 0.9375 18.6875H14.0625C14.4255 18.6875 14.7188 18.3942 14.7188 18.0312V5.38408C14.7188 5.20977 14.649 5.0416 14.526 4.91855ZM13.2053 5.68555H9.3457V1.82598L13.2053 5.68555ZM13.2422 17.2109H1.75781V1.78906H7.95117V6.21875C7.95117 6.44719 8.04192 6.66627 8.20345 6.8278C8.36498 6.98933 8.58406 7.08008 8.8125 7.08008H13.2422V17.2109ZM8.15625 8.67969C8.15625 8.58945 8.08242 8.51562 7.99219 8.51562H7.00781C6.91758 8.51562 6.84375 8.58945 6.84375 8.67969V10.8945H4.62891C4.53867 10.8945 4.46484 10.9684 4.46484 11.0586V12.043C4.46484 12.1332 4.53867 12.207 4.62891 12.207H6.84375V14.4219C6.84375 14.5121 6.91758 14.5859 7.00781 14.5859H7.99219C8.08242 14.5859 8.15625 14.5121 8.15625 14.4219V12.207H10.3711C10.4613 12.207 10.5352 12.1332 10.5352 12.043V11.0586C10.5352 10.9684 10.4613 10.8945 10.3711 10.8945H8.15625V8.67969Z" fill="#999999"/>
                                                </svg>
                                            </span>
                                            <span @click="openDeleteGroupModal" v-if="userGroups.active" class="cursor-pointer" title="Delete FM team" v-b-tooltip.hover>
                                                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.5 4.5H16.5" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M5.66699 4.49984V2.83317C5.66699 2.39114 5.84259 1.96722 6.15515 1.65466C6.46771 1.3421 6.89163 1.1665 7.33366 1.1665H10.667C11.109 1.1665 11.5329 1.3421 11.8455 1.65466C12.1581 1.96722 12.3337 2.39114 12.3337 2.83317V4.49984M14.8337 4.49984V16.1665C14.8337 16.6085 14.6581 17.0325 14.3455 17.345C14.0329 17.6576 13.609 17.8332 13.167 17.8332H4.83366C4.39163 17.8332 3.96771 17.6576 3.65515 17.345C3.34259 17.0325 3.16699 16.6085 3.16699 16.1665V4.49984H14.8337Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7.33301 8.6665V13.6665" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10.667 8.6665V13.6665" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </div>
                                    </template>
                                    <gofix-form-input label="Search" v-model="search"></gofix-form-input>
                                    <ul class="fmTeamItems">
                                        <li class="fmTeamItem" @click="changeGroupID(usergroup.id)" v-bind:class="{active :usergroup.id === userGroups.active}" v-for="usergroup in filteredItems">
                                            <span class="name">{{usergroup.group_name}}</span>
                                            <span class="action" v-on:click.stop="openGroupModal(usergroup)">
                                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.709 3.63102C18.099 4.02102 18.099 4.65102 17.709 5.04102L15.879 6.87102L12.129 3.12102L13.959 1.29102C14.1459 1.10377 14.3995 0.998535 14.664 0.998535C14.9285 0.998535 15.1822 1.10377 15.369 1.29102L17.709 3.63102ZM-0.000976562 18.501V15.461C-0.000976562 15.321 0.0490234 15.201 0.149023 15.101L11.059 4.19102L14.809 7.94102L3.88902 18.851C3.79902 18.951 3.66902 19.001 3.53902 19.001H0.499023C0.219023 19.001 -0.000976562 18.781 -0.000976562 18.501Z" fill="#999999"/>
                                                </svg>
                                            </span>
                                        </li>
                                    </ul>
                                </gofix-card>
                            </template>
                            <template slot="gofixSplit:right">
                                <gofix-card fullContent class="mb-0">
                                    <gofix-default-table
                                            class="scrollRightArea"
                                            :settings="tableConfig"
                                            :table-items="tableItems"
                                            @load-items="getTableData"
                                            @new-item="openCreateItem"
                                            @row-click="openCreateItem"
                                            @delete-items="deleteItems"
                                            ref="gofixTable">
                                        <template slot="gofix_table:after-control-left-selected">
                                            <li class="control-item">
                                                <a class="control-item-link cursor-pointer" @click="openAssignGroupModal" title="Add user to team" v-b-tooltip.hover>
                                                    <img class="h-21" src="img/add-team.png" alt="Add user to team">
                                                </a>
                                            </li>
                                            <li class="control-item" v-if="userGroups.active">
                                                <a class="control-item-link cursor-pointer" @click="openRemoveUserFromGroupModal" title="Remove user from team" v-b-tooltip.hover>
                                                    <img class="h-21" src="img/remove-team.png" alt="Remove user from team">
                                                </a>
                                            </li>
                                        </template>
                                        <template slot="gofix_table:active" slot-scope="row">
                                            <span class="text-highlight">{{ row.item.active ? "Active" : "Inactive" }}</span>
                                        </template>
                                        <template slot="gofix_table:start_date" slot-scope="row">
                                            {{ row.item.start_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                                        </template>
                                        <template slot="gofix_table:user_teams" slot-scope="row">
                                            {{ row.item.user_teams ? row.item.user_teams.replaceAll(",", ", ") : '' }}
                                        </template>
                                        <template slot="gofix_table:end_date" slot-scope="row">
                                            {{ row.item.end_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                                        </template>
                                    </gofix-default-table>
                                </gofix-card>
                            </template>
                        </gofix-split>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true"
                 id="modal-Create"
                 :title="modals.create.title" hide-footer :centered="true"
                 v-model="modals.create.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Select by Name or Email"
                                desc="Search by name or email"
                                @search="searchUser"
                                @change="selectUser"
                                :filterable="false"
                                :required="true"
                                :disabled="!!modals.create.data.id"
                                v-model="officerName"
                                :options="modals.create.users.data">
                            <template #gofixInput:dropdown:option="{ name, email }">
                                {{name}} - {{email}}
                            </template>
                            <template #gofixInput:dropdown:selected-option="{ name, email }">
                                {{name}} - {{email}}
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Role"
                                vLabel="name"
                                :filterable="false"
                                :multiple="!modals.create.data.id"
                                :required="true"
                                :reduce="option => option.id"
                                v-model="modals.create.data.role_id"
                                :options="modals.create.roles">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-properties
                                label="Property"
                                :contract-id="$route.params.id"
                                :property-id="ClientContractID ? ClientContractID.property_root_id : null"
                                v-model="modals.create.data.property"
                                valueFormat="object"
                                required>
                        </gofix-form-properties>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-tree
                            label="Service Category"
                            :default-expand-level="1"
                            :multiple="false"
                            :options="modals.create.service_categorys"
                            :load-options="loadOptionServices"
                            :normalizer="normalizer"
                            search-nested
                            valueFormat="object"
                            v-model="modals.create.data.service_category"
                            placeholder="Select"
                            ref="input">
                        </gofix-form-tree>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                                v-model="start_date"
                                label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                                v-model="end_date"
                                label="End Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="FM Team"
                            vLabel="group_name"
                            :filterable="false"
                            :multiple="true"
                            :required="true"
                            :clearable="false"
                            v-model="modals.create.data.groups"
                            :options="userGroups.items">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="ADD NEW USER" :dark="true" class="text-light-back" @click="addNewUser" noBorder></gofix-button>
                <gofix-button label="APPLY" @click="saveData" :loading="modals.create.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 id="modal-Create"
                 :title="modals.group.title" hide-footer :centered="true"
                 v-model="modals.group.open">
            <b-form class="pb-20">
                <gofix-form-input label="Team Name" v-model="modals.group.data.group_name" required></gofix-form-input>
                <gofix-form-input-textarea label="Description" :rows="5"  v-model="modals.group.data.description"></gofix-form-input-textarea>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="saveUserGroup" :loading="modals.group.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 id="modal-Create"
                 :title="modals.assign.title" hide-footer :centered="true"
                 v-model="modals.assign.open">
            <b-form class="pb-20">
                <gofix-form-dropdown
                    label="FM Team"
                    vLabel="group_name"
                    :reduce="option => option.id"
                    :filterable="false"
                    :clearable="false"
                    v-model="modals.assign.data.group_id"
                    :options="userGroups.items">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="assignUserToGroup" :loading="modals.assign.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove user from group" hide-footer hide-header :centered="true" v-model="modals.remove.open">
            <div class="center">Are you sure you want to<br/>remove <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.remove.open = false">No</b-button>
                <b-button class="custom-btn" @click="removeUserFromGroup" :disabled="modals.remove.loading">
                    <b-spinner v-if="modals.remove.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove user from group" hide-footer hide-header :centered="true" v-model="modals.removeGroup.open">
            <div class="center">Are you sure you want to<br/>remove <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.removeGroup.open = false">No</b-button>
                <b-button class="custom-btn" @click="removeGroup" :disabled="modals.removeGroup.loading">
                    <b-spinner v-if="modals.removeGroup.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
    import { filters } from '@/_filterVar.js'
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500);
    };
    export default {
        name: 'contract-fm-officers',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['contract_user_duty']));
            return {
                contract_tab: tabData.client_contract,
                tableConfig:{
                    name: 'client-contract-fm-officers',
                    controls:{
                        tableExport: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "user_id",
                    sortDirection: "asc",
                },
                tableItems: [],
                modals:{
                    create:{
                        open: false,
                        loading: false,
                        title:"Assign FM officer",
                        data:{
                            id: null,
                            property_id: null,
                            property: null,
                            service_category_id: null,
                            service_category: null,
                            contract_id: this.$route.params.id,
                            user_id: null,
                            role_id: null,
                            start_date: null,
                            end_date: null,
                            groups: [],
                            type: "FM Officer"
                        },
                        users:{
                            data:[],
                            timer: null
                        },
                        properties:[],
                        roles:[],
                        service_categorys: []
                    },
                    group:{
                        open: false,
                        loading:false,
                        title: "Add FM Team",
                        data: {
                            id: null,
                            group_name: null,
                            description: null,
                            contract_id: this.$route.params.id,
                        }
                    },
                    assign:{
                        open: false,
                        loading: false,
                        title: "Add FM Officer to FM",
                        data:{
                            user_duty_ids: null,
                            group_id: null
                        }
                    },
                    remove: {
                        open: false,
                        loading: false,
                        data:{
                            user_duty_ids: null,
                            group_id: null
                        }
                    },
                    removeGroup: {
                        open: false,
                        loading: false,
                    },
                },
                officerName: null,
                end_date: null,
                start_date: null,
                userGroups: {
                    items: [],
                    loading: false,
                    active: null,
                },
                search: '',
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
            filteredItems:function()
            {
                var self=this;
                return this.userGroups.items.filter(function(item){return item.group_name.toLowerCase().indexOf(self.search.toLowerCase())>=0;});        
            }
        },
        watch: {
            ClientContractID: function (val, old) {
                if (!val) {
                    return this.$router.push(`/v2/contract-client`)
                } 
                if(val != old){
                    this.getUserGroup();
                    // this.getUsers();
                    this.loadRootServiceCategory();
                }
            },
            'userGroups.active': function (val, old) {
                if(val && val.id) {
                    this.getUserGroup();
                }
            },
        },
        created() {
            // if(this.ClientContractID && this.ClientContractID.id) 
            //     this.getUsers();
            this.getLocaltion();
            this.getUserGroup();
            this.loadRootServiceCategory();
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.user_type.value = 'FM Officer';
                tableRequest.filter.id.value = this.userGroups.active;
                if(tableRequest.filter.contract_id.value) {
                    await this.$store.dispatch("UserDutyController/getItems", tableRequest)
                        .then(response => {
                            this.tableItems = response.items;
                            this.tableConfig.total = response.total;
                            resolve(response);
                        })
                        .catch(err => {
                            console.log(err);
                            this.$alertNotification("Can not load the items", "danger");
                            reject();
                        })
                }
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("UserDutyController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'fm_officer'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            saveData() {
                if(!this.modals.create.data.id && !this.officerName) return this.$alertNotification("Please select a user", "danger");
                if(!this.modals.create.data.role_id) return this.$alertNotification("Please select a role", "danger");
                if(!this.modals.create.data.property) return this.$alertNotification("Please select a property", "danger");
                if(!this.modals.create.data.service_category) return this.$alertNotification("Please select a service category", "danger");

                if(this.modals.create.loading) return;
                this.modals.create.loading = true;
                let request = JSON.parse(JSON.stringify(this.modals.create.data));
                request.property_id = request.property ? request.property.id : null;
                request.service_category_id = request.service_category ? request.service_category.id : null;
                request.start_date = this.start_date ? moment(this.start_date).format("YYYY-MM-DD") : null;
                request.end_date = this.end_date ? moment(this.end_date).format("YYYY-MM-DD") : null;
                request.user_id = this.officerName ? this.officerName.id : null;
                let action = 'createItem';
                let keyMsg = 'adding'
                if(this.modals.create.data.id){
                    action = 'updateItem';
                    keyMsg = 'editing'
                }
                this.$store.dispatch(`UserDutyController/${action}`, request)
                    .then(result => {
                        this.modals.create.loading = false;
                        this.modals.create.open = false;
                        //this.$notificationV2('custom', 'user_duty_assign')
                        this.$alertNotification(this.$notificationV2(keyMsg, 'fm_officer'));
                        this.$store.dispatch("AuthController/getRoles");
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.modals.create.loading = false;
                        return this.$alertNotification(error.response.data.error.message.error, "danger");
                    })
            },
            selectUser(item){
                this.modals.create.roles = item.roles;
                this.modals.create.data.role_id = item.roles.map(x => x.id);
                if(item.user_groups && item.user_groups.length){
                    this.modals.create.data.groups = item.user_groups.filter((item)=>{
                        return item.contract_id == this.$route.params.id
                    });
                }

            },
            openCreateItem(item){
                this.getUsers();
                this.modals.create.open = true;
                if(item){
                    this.modals.create.title = "Edit Assign FM officer";
                    this.modals.create.title = "FM officer";
                    this.modals.create.data = {
                        id: item.id,
                        property_id:  item.property_id,
                        property: {
                            "id": item.property_id,
                            "name": item.property_name,
                            "text": item.property_name,
                            "data": {
                                "id": item.property_id,
                                "name": item.property_name,
                            },
                        },
                        service_category_id: item.service_category_id ? item.service_category_id : null,
                        service_category: item.service_category_id ? {
                            "id": item.service_category_id,
                            "name": item.service_category_name,
                            "text": item.service_category_name,
                            "data": {
                                "id": item.service_category_id,
                                "name": item.service_category_name,
                            },
                        } : null,
                        contract_id: this.$route.params.id,
                        user_id: {
                            id: item.user_id,
                            name:item.user_name,
                            email:item.user_email,
                        },
                        role_id: item.role_id,
                        type: "FM Officer",
                        groups: item.user_groups
                    };
                    this.officerName = {
                        id: item.user_id,
                        name:item.user_name,
                        email:item.user_email,
                    }
                    this.start_date = item.start_date ? moment(item.start_date).toDate() : null;
                    this.end_date = item.end_date ? moment(item.end_date).toDate() : null;
                    for( let i = 0 ; i <  this.modals.create.users.data.length ; i++ ){
                        if(item.user_id === this.modals.create.users.data[i].id){
                            this.modals.create.roles = this.modals.create.users.data[i].roles;
                        }
                    }

                    // Get role user
                    this.$store.dispatch('v2UserController/getUser', item.user_id)
                    .then(response => {
                        if(response.data.data && response.data.data.roles) {
                            this.modals.create.roles = response.data.data.roles
                        } else {
                            this.modals.create.roles = [{
                                id: item.role_id,
                                name:item.role_name,
                            }]
                        }
                     })
                    .catch(error => {})
                }else{
                    this.modals.create.title = "Assign FM officer";
                    this.modals.create.data = {
                        id: null,
                        property_id: null,
                        property: null,
                        service_category_id: null,
                        service_category: null,
                        contract_id: this.$route.params.id,
                        user_id: null,
                        role_id: null,
                        start_date: null,
                        end_date: null,
                        type: "FM Officer",
                        groups: this.userGroups.active ? this.userGroups.items.filter((item)=>{
                            return item.id === this.userGroups.active
                        }) : []
                    };
                    this.start_date = null;
                    this.end_date = null;
                    this.officerName = null;
                }
            },
            getUsers(search = ''){
                let params = { page: 1, totalPage: 0, limit: 100, filters: { name: search, organization_isfm : true, organisation_id: this.ClientContractID && this.ClientContractID.supplier_id ? this.ClientContractID.supplier_id : null } };
                if(this.userGroups.active){
                    if(process.env.VUE_APP_IS_EME == 'true'){
                        params.filters.client_contract_id = this.$route.params.id;
                    }
                }
                if(search) {
                    params.filters.or = true;
                    params.filters.email = search;
                }
                this.$store.dispatch("v2UserController/searchListUser", params)
                    .then(result=>{
                        this.modals.create.users.data = result.data
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            searchUser (search, loading){
                loading(true);
                if(this.modals.create.users.timer) {
                    clearTimeout(this.modals.create.users.timer);
                    this.modals.create.users.timer = null;
                }
                this.modals.create.users.timer = setTimeout(async () => {
                    try {
                        await this.getUsers(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            normalizer(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children,
                    };
                return {
                    id: node.data.id,
                    label: node.text,
                    children: undefined
                };
            },
            loadOptions({action,parentNode,callback}) {
                if (action === LOAD_CHILDREN_OPTIONS) {
                    if (parentNode.children) {
                        parentNode.children = parentNode.children;
                        callback();
                        return;
                    }
                    if (parentNode.data.isBatch) {
                        global
                            .axios(
                                `api/contracts/${this.$route.params.id}/tree-properties/${parentNode.data.id}`, {
                                    method: "GET",
                                    data: {},
                                    headers: {
                                        Accept: "application/json"
                                    }
                                }
                            )
                            .then(result => {
                                simulateAsyncOperation(() => {
                                    parentNode.children = result.data.data;
                                    callback();
                                });
                            });
                    } else {
                        parentNode.children = [];
                        callback();
                    }
                }
            },
            getLocaltion() {
                global.axios(`api/contracts/${this.$route.params.id}/tree-properties/0`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                    .then(response => {
                        this.modals.create.properties = response.data.data;
                    })
                    .catch(error => reject(error));
            },
            goToDetail(){
                //if(this.contract_staff)
                //return this.$router.push(`/v2/contract-client/${this.$route.params.id}/fm-officers/${this.contract_staff.id}`);
                return this.$router.push(`/v2/contract-client/${this.$route.params.id}/fm-officers/add`);
            },
            addNewUser() {
                return this.$router.push(`/v2/users/fm-officer/add`);
            },
            openGroupModal(item){
                if(item !== 1){
                    this.modals.group.data.id = item.id;
                    this.modals.group.data.group_name = item.group_name;
                    this.modals.group.data.description = item.description;
                    this.modals.group.title = "Edit FM Team";
                }else{
                    this.modals.group.data.id = null;
                    this.modals.group.data.group_name = null;
                    this.modals.group.data.description = null;
                    this.modals.group.title = "Add FM Team";
                }

                this.modals.group.open = true;
            },
            openDeleteGroupModal(){
                this.modals.removeGroup.open = true;
            },

            //Get list user group
            getUserGroup(){
                if(this.userGroups.loading) return;
                this.userGroups.loading = true;

                this.$store.dispatch("UserGroupController/getItems", {
                    page: 1,
                    limit: -1,
                    filter: {
                        contract_id: this.$route.params.id
                    }
                })
                    .then(response => {
                        this.userGroups.items = response.items;
                        this.userGroups.loading = false;
                    })
                    .catch(err => {
                        this.userGroups.items = [];
                        this.userGroups.loading = false;
                    })
            },
            saveUserGroup(){
                if(this.modals.group.loading) return;
                this.modals.group.loading = true;
                if(!this.modals.group.data.group_name){
                    return this.$alertNotification("Please fill to FM team name", "danger");
                }
                let action = "createItem";
                if(this.modals.group.data.id){
                    action = "updateItem";
                }
                this.$store.dispatch(`UserGroupController/${action}`, this.modals.group.data)
                    .then(result => {
                        this.modals.group.loading = false;
                        this.modals.group.open = false;
                        this.$alertNotification(`Successfully ${action === 'createItem' ? 'added' : 'updated'} user group`);
                        this.getUserGroup();
                    })
                    .catch(error => {
                        this.modals.create.loading = false;
                        return this.$alertNotification(error.response.data.error.message.error, "danger");
                    })
            },
            changeGroupID(id){
                this.userGroups.active = id;
                this.$refs.gofixTable.reloadTableKeepFilter();
                window.scrollTo(0,0);
            },
            openAssignGroupModal(){
                if(!this.$refs.gofixTable.tableSelected.selected){
                    this.$alertNotification("Please select a item", "warning");
                }
                this.modals.assign.data.user_duty_ids = this.$refs.gofixTable.tableSelected.selected;
                this.modals.assign.open = true;
            },
            assignUserToGroup(){
                if(this.modals.assign.loading) return;
                this.modals.assign.loading = true;
                if(!this.modals.assign.data.group_id){
                    this.modals.assign.loading = false;
                    return this.$alertNotification("Please select a FM team", "danger");
                }

                this.$store.dispatch(`UserGroupController/assign`, this.modals.assign.data)
                    .then(result => {
                        this.modals.assign.loading = false;
                        this.modals.assign.open = false;
                        this.$alertNotification(`Successfully assign user to group`);
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$store.dispatch('AuthController/getUser');
                    })
                    .catch(error => {
                        this.modals.assign.loading = false;
                        if(error.response.data.error.message.error) {
                            return this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    })
            },
            openRemoveUserFromGroupModal(){
                if(!this.$refs.gofixTable.tableSelected.selected){
                    this.$alertNotification("Please select a item", "warning");
                }
                this.modals.remove.data.user_duty_ids = this.$refs.gofixTable.tableSelected.selected;
                this.modals.remove.data.group_id = this.userGroups.active;
                this.modals.remove.open = true;
            },
            removeUserFromGroup(){
                //removeUserFromGroup
                if(this.modals.remove.loading) return;
                this.modals.remove.loading = true;
                if(!this.modals.remove.data.group_id){
                    return this.$alertNotification("Please select a FM team", "danger");
                }
                this.$store.dispatch(`UserGroupController/removeUserFromGroup`, this.modals.remove.data)
                    .then(result => {
                        this.modals.remove.loading = false;
                        this.modals.remove.open = false;
                        this.$alertNotification(`Successfully removed user from group`);
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$store.dispatch('AuthController/getUser');
                    })
                    .catch(error => {
                        this.modals.remove.loading = false;
                        if(error.response.data.error.message.error) {
                            return this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    })
            },
            removeGroup(){
                //removeUserFromGroup
                if(this.modals.removeGroup.loading) return;
                this.modals.removeGroup.loading = true;
                if(!this.userGroups.active){
                    return this.$alertNotification("Please select a FM team", "danger");
                }
                this.$store.dispatch(`UserGroupController/deleteItems`, [this.userGroups.active])
                    .then(result => {
                        this.modals.removeGroup.loading = false;
                        this.modals.removeGroup.open = false;
                        this.userGroups.active = null;
                        this.$alertNotification(`Successfully removed group`);
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$store.dispatch('AuthController/getUser');
                        this.getUserGroup();
                    })
                    .catch(error => {
                        this.modals.remove.loading = false;
                        if(error.response.data.error.message.error) {
                            return this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    })
            },
            loadRootServiceCategory(){
                this.$store.dispatch('ServiveCategoryController/getServiceCategories', {
                    contractId: this.$route.params.id,
                    categoryId: 0
                }).then(response => {
                    this.modals.create.service_categorys = response;
                });
            },
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("ServiveCategoryController/getServiceCategories", {
                        contractId: this.$route.params.id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                } else {
                    callback();
                }
            },
        }
    }
</script>